import { proxy } from "valtio";

const uiState = proxy({
  security: { visible: false },
  ga: { isInit: false },
  bgm: {
    isMusicPlay: false,
    prevPlayState: false,
    bgmSrc: "",
    controlForFQC: false,
  },
  trumpetIframe: { visible: false },
  saxIframe: { visible: false },
  frenchhornIframe: { visible: false },
  tromboneIframe: { visible: false },
  susIframe: { visible: false },
  transitionPage: {
    visible: false,
    text: "",
    //     data: {
    //       sax: `Switch
    // To
    // Saxophone...`,
    //       trumpet: `Switch
    // To
    // Trumpet...`,
    //       frenchhorn: `Switch
    // To
    // frenchhorn...`,
    //       trombone: `Switch
    // To
    // trombone...`,
    //       sus: `Switch
    // To
    // Sustainability...`,
    //     },
    data: {}, // 先放空
  },

  homepage: {
    visible: true,
  },
  enterPage: {
    visible: false,
    hoverItem: "",
  },
  communityPage: {
    visible: false,
    currentImageIndex: 0,
  },
  factorySpa: {
    visible: false,
  },
  environmentSpa: {
    visible: false,
  },
  factoryEntrance: {
    visible: false,
  },
  toolbox: {
    visible: true,
    isOpen: false,
    isOpenForAnimation: false,
  },
});
window.uiState = uiState;

// 初始化時讀 JSON
fetch("./transitionText.json")
  .then((res) => res.json())
  .then((data) => {
    uiState.transitionPage.data = data.transitionPage;
  });
export default uiState;
